// Имя файла для карточки вложения: head обрезается многоточием, tail
// (последние 3 символа имени + расширение) виден всегда. Расширение берётся из
// самого имени по последней точке, а не из file.ext: тот обрезан до 3 символов
// (webp → web) и из-за этого имя собиралось криво («team.p.web»).
const TAIL_LENGTH = 3;

export default function splitFileName(filename) {
  const name = typeof filename === "string" ? filename : "";
  const dot = name.lastIndexOf(".");
  // ".env" и "file." считаем именами без расширения
  const hasExt = dot > 0 && dot < name.length - 1;
  const base = hasExt ? name.slice(0, dot) : name;
  const ext = hasExt ? name.slice(dot) : "";
  const cut = Math.max(base.length - TAIL_LENGTH, 0);

  return { head: base.slice(0, cut), tail: base.slice(cut) + ext };
}
